import { render, staticRenderFns } from "./MianZeTiaoKuanView.vue?vue&type=template&id=29694b20&scoped=true"
import script from "./MianZeTiaoKuanView.vue?vue&type=script&lang=js"
export * from "./MianZeTiaoKuanView.vue?vue&type=script&lang=js"
import style0 from "./MianZeTiaoKuanView.vue?vue&type=style&index=0&id=29694b20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29694b20",
  null
  
)

export default component.exports